(() => {
  const SELECTOR = '[data-plexigo-google-business]';
  let mapsPromise;
  let mapsAuthError = null;

  function friendlyGoogleError(error) {
    const raw = String(error?.message || error || '').trim();
    const lower = raw.toLowerCase();
    if (!raw) return 'Google Places isteği başarısız oldu.';
    if (lower.includes('referer') || lower.includes('referrer') || lower.includes('not authorized')) return 'API anahtarı bu mağaza alan adı için yetkili değil.';
    if (lower.includes('billing')) return 'Google Maps Platform için faturalandırma etkin görünmüyor.';
    if (lower.includes('api project is not authorized') || lower.includes('api_not_activated') || lower.includes('not activated')) return 'Maps JavaScript API ve Places API (New) erişimini kontrol edin.';
    if (lower.includes('invalidkey') || lower.includes('invalid key') || lower.includes('api key')) return 'Google Maps API anahtarı geçersiz veya kısıtlaması hatalı görünüyor.';
    return `Google Places hatası: ${raw}`;
  }

  function loadGoogleMaps(apiKey) {
    if (window.google?.maps?.importLibrary) return Promise.resolve(window.google.maps);
    if (!apiKey) return Promise.reject(new Error('Google Maps API anahtarı tanımlı değil.'));
    if (mapsPromise) return mapsPromise;
    mapsPromise = new Promise((resolve, reject) => {
      const previousAuthFailure = window.gm_authFailure;
      window.gm_authFailure = () => {
        mapsAuthError = new Error('RefererNotAllowedMapError / Google Maps authentication failed');
        if (typeof previousAuthFailure === 'function') previousAuthFailure();
      };
      const ready = () => {
        if (mapsAuthError) return reject(mapsAuthError);
        if (window.google?.maps?.importLibrary) return resolve(window.google.maps);
        reject(new Error('Google Maps JavaScript API yüklendi ancak importLibrary kullanılamıyor.'));
      };
      const existing = document.querySelector('script[data-plexigo-google-maps]');
      if (existing) {
        if (window.google?.maps?.importLibrary) return resolve(window.google.maps);
        existing.addEventListener('load', ready, { once: true });
        existing.addEventListener('error', () => reject(new Error('Google Maps JavaScript dosyası yüklenemedi.')), { once: true });
        setTimeout(ready, 1500);
        return;
      }
      const callbackName = `__plexigoGoogleMapsReady_${Date.now()}`;
      window[callbackName] = () => { try { ready(); } finally { setTimeout(() => { try { delete window[callbackName]; } catch (_) {} }, 0); } };
      const script = document.createElement('script');
      script.dataset.plexigoGoogleMaps = 'true';
      script.async = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&loading=async&libraries=places&v=weekly&language=tr&region=TR&callback=${encodeURIComponent(callbackName)}`;
      script.onerror = () => reject(new Error('Google Maps JavaScript dosyası yüklenemedi.'));
      document.head.appendChild(script);
      setTimeout(() => { if (!window.google?.maps?.importLibrary) reject(mapsAuthError || new Error('Google Maps yükleme zaman aşımına uğradı.')); }, 15000);
    });
    return mapsPromise;
  }

  const escapeHtml = (value = '') => String(value).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  const stars = (rating) => { const value = Math.max(0, Math.min(5, Math.round(Number(rating) || 0))); return '★'.repeat(value) + '☆'.repeat(5-value); };

  function init(root) {
    if (!root || root.dataset.plexigoReady === 'true') return;
    root.dataset.plexigoReady = 'true';
    const form = root.closest('form');
    if (!form) return;

    const apiKey = root.dataset.apiKey || '';
    const searchInput = root.querySelector('[data-plexigo-place-search]');
    const results = root.querySelector('[data-plexigo-place-results]');
    const loader = root.querySelector('[data-plexigo-search-loader]');
    const emptyState = root.querySelector('[data-plexigo-empty-state]');
    const selected = root.querySelector('[data-plexigo-selected]');
    const selectedName = root.querySelector('[data-plexigo-selected-name]');
    const selectedRating = root.querySelector('[data-plexigo-selected-rating]');
    const selectedAddress = root.querySelector('[data-plexigo-selected-address]');
    const clearBtn = root.querySelector('[data-plexigo-place-clear]');
    const error = root.querySelector('[data-plexigo-error]');
    const manualName = root.querySelector('[data-plexigo-manual-name]');
    const manualLink = root.querySelector('[data-plexigo-manual-link]');
    const manualSave = root.querySelector('[data-plexigo-manual-save]');
    const fields = {
      name: root.querySelector('[data-plexigo-property-name]'),
      placeId: root.querySelector('[data-plexigo-property-place-id]'),
      reviewUri: root.querySelector('[data-plexigo-property-review-uri]'),
      placeUri: root.querySelector('[data-plexigo-property-place-uri]'),
      address: root.querySelector('[data-plexigo-property-address]'),
    };

    let searchTimer;
    let placePredictions = [];
    let placesLib = null;
    let sessionToken = null;
    let selectedSearchText = '';
    const productForm = root.closest('product-form');
    const submitButton = productForm?.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"][name="add"]');
    const shopifyDisabledAtInit = Boolean(submitButton?.disabled);

    const hasSelection = () => Boolean(fields.name?.value && fields.reviewUri?.value);
    const conditionalMode = root.dataset.plexigoConditional === 'true';
    const isConditionallyActive = () => {
      if (!conditionalMode) return true;
      const detail = root.closest('[data-plexigo-qr-detail]');
      return Boolean(detail && !detail.hidden && detail.dataset.plexigoSelected === 'true');
    };
    function syncSubmit(){
      if(!submitButton)return;
      if(!isConditionallyActive()){
        submitButton.removeAttribute('data-plexigo-google-disabled');
        submitButton.removeAttribute('aria-disabled');
        if(!shopifyDisabledAtInit && !submitButton.hasAttribute('data-plexigo-disabled')) submitButton.removeAttribute('disabled');
        return;
      }
      if(hasSelection()){
        submitButton.removeAttribute('data-plexigo-google-disabled');
        submitButton.removeAttribute('aria-disabled');
        if(!shopifyDisabledAtInit && !submitButton.hasAttribute('data-plexigo-disabled')) submitButton.removeAttribute('disabled');
      }else{
        submitButton.dataset.plexigoGoogleDisabled='true';
        submitButton.setAttribute('aria-disabled','true');
        submitButton.setAttribute('disabled','disabled');
      }
    }
    function showError(message){ if(!error)return; error.textContent=message||''; error.hidden=!message; }
    function setLoading(on){ if(loader) loader.hidden=!on; }
    function hideResults(){ if(results){ results.hidden=true; results.innerHTML=''; } }
    function showResults(){ if(results) results.hidden=false; }
    async function ensurePlaces(){ await loadGoogleMaps(apiKey); if(!placesLib) placesLib=await google.maps.importLibrary('places'); if(!sessionToken&&placesLib.AutocompleteSessionToken)sessionToken=new placesLib.AutocompleteSessionToken(); return placesLib; }
    function newSession(){ sessionToken=placesLib?.AutocompleteSessionToken ? new placesLib.AutocompleteSessionToken() : null; }

    function clearSelection({focus=false, preserveInput=false}={}){
      Object.values(fields).forEach((field)=>{ if(field) field.value=''; });
      if(selected) selected.hidden=true;
      if(emptyState) emptyState.hidden=false;
      if(!preserveInput && searchInput) searchInput.value='';
      selectedSearchText='';
      showError(''); hideResults(); syncSubmit(); newSession();
      if(focus) setTimeout(()=>searchInput?.focus(),30);
    }

    function saveSelection(data){
      fields.name.value=data.name||''; fields.placeId.value=data.placeId||''; fields.reviewUri.value=data.reviewUri||''; fields.placeUri.value=data.placeUri||''; fields.address.value=data.address||'';
      if(selectedName) selectedName.textContent=data.name||'';
      if(selectedAddress) selectedAddress.textContent=data.address||'';
      if(selectedRating){ selectedRating.innerHTML=data.rating ? `<span>${escapeHtml(data.rating)}</span><span class="plexigo-google-business__stars">${escapeHtml(stars(data.rating))}</span>${data.reviewCount?`<span>${escapeHtml(data.reviewCount)} yorum</span>`:''}` : ''; }
      if(searchInput){ searchInput.value=data.name||''; selectedSearchText=searchInput.value; }
      if(emptyState) emptyState.hidden=true;
      if(selected) selected.hidden=false;
      showError(''); hideResults(); syncSubmit(); newSession();
    }

    async function searchPlaces(query){
      showResults(); setLoading(true); showError('');
      results.innerHTML='<div class="plexigo-google-business__loading">Google üzerinde aranıyor…</div>';
      try{
        const {AutocompleteSuggestion}=await ensurePlaces();
        if(!AutocompleteSuggestion?.fetchAutocompleteSuggestions) throw new Error('Places Autocomplete Data API tarayıcıda kullanılamıyor.');
        const request={input:query,language:'tr',region:'tr',includedRegionCodes:['tr']}; if(sessionToken)request.sessionToken=sessionToken;
        const {suggestions}=await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
        placePredictions=(suggestions||[]).map(i=>i.placePrediction).filter(Boolean); renderResults();
      }catch(e){ console.error('[PlexiGo Places search]',e); const message=friendlyGoogleError(e); results.innerHTML=`<div class="plexigo-google-business__empty">İşletme araması başlatılamadı.<br><small>${escapeHtml(message)}</small></div>`; showError(message); }
      finally{ setLoading(false); }
    }

    function renderResults(){
      showResults();
      if(!placePredictions.length){results.innerHTML='<div class="plexigo-google-business__empty">Sonuç bulunamadı. İşletme adıyla birlikte ilçe veya şehir yazmayı deneyin.</div>';return;}
      results.innerHTML=placePredictions.map((prediction,index)=>{const name=prediction.mainText?.text||prediction.text?.text||'';const address=prediction.secondaryText?.text||'';return `<article class="plexigo-google-business__result"><div class="plexigo-google-business__result-main"><span class="plexigo-google-business__g">G</span><div class="plexigo-google-business__result-copy"><strong>${escapeHtml(name)}</strong><div class="plexigo-google-business__result-address">${escapeHtml(address)}</div></div></div><button type="button" data-plexigo-result-index="${index}">Seç</button></article>`;}).join('');
    }

    async function selectPlace(index){
      const prediction=placePredictions[index]; if(!prediction)return;
      const clicked=results.querySelector(`[data-plexigo-result-index="${index}"]`); if(clicked){clicked.disabled=true;clicked.textContent='Seçiliyor…';}
      const placeId=prediction.placeId||''; const fallbackName=prediction.mainText?.text||prediction.text?.text||''; const fallbackAddress=prediction.secondaryText?.text||'';
      const reviewUri=placeId?`https://search.google.com/local/writereview?placeid=${encodeURIComponent(placeId)}`:'';
      const fallbackPlaceUri=placeId?`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fallbackName||fallbackAddress||'Google Maps')}&query_place_id=${encodeURIComponent(placeId)}`:'';
      if(!placeId||!reviewUri){showError('Bu Google sonucunda geçerli bir Place ID alınamadı. Başka bir sonuç seçin.'); if(clicked){clicked.disabled=false;clicked.textContent='Seç';} return;}
      let data={name:fallbackName,placeId,reviewUri,placeUri:fallbackPlaceUri,address:fallbackAddress,rating:'',reviewCount:''};
      try{const place=prediction.toPlace();await place.fetchFields({fields:['displayName','formattedAddress','rating','userRatingCount','googleMapsURI','googleMapsLinks']});data={...data,name:place.displayName||data.name,address:place.formattedAddress||data.address,rating:place.rating||'',reviewCount:place.userRatingCount||'',reviewUri:data.reviewUri,placeUri:place.googleMapsLinks?.placeURI||place.googleMapsURI||data.placeUri};}catch(e){console.warn('[PlexiGo Places details]',e);}
      saveSelection(data);
    }

    searchInput?.addEventListener('focus',()=>{ if(searchInput.value.trim().length>=3 && !hasSelection()) searchPlaces(searchInput.value.trim()); });
    searchInput?.addEventListener('input',()=>{
      clearTimeout(searchTimer); const q=searchInput.value.trim();
      if(hasSelection() && searchInput.value!==selectedSearchText) clearSelection({preserveInput:true});
      if(/^https?:\/\//i.test(q)) { hideResults(); showError('Google yorum linkini doğrudan kullanmak için aşağıdaki “İşletmenizi bulamıyor musunuz?” alanını açın.'); return; }
      showError('');
      if(q.length<3){hideResults();return;}
      searchTimer=setTimeout(()=>searchPlaces(q),320);
    });
    results?.addEventListener('click',(event)=>{const button=event.target.closest('[data-plexigo-result-index]');if(!button)return;selectPlace(Number(button.dataset.plexigoResultIndex));});
    root.addEventListener('plexigo:conditional-change', syncSubmit);
    clearBtn?.addEventListener('click',()=>clearSelection({focus:true}));
    manualSave?.addEventListener('click',()=>{const name=manualName?.value.trim()||'';const reviewUri=manualLink?.value.trim()||'';if(!name||!/^https?:\/\//i.test(reviewUri)){showError('Manuel kullanım için işletme adını ve geçerli Google yorum linkini girin.');return;}saveSelection({name,reviewUri,placeId:'',placeUri:'',address:'Manuel Google yorum bağlantısı'});});
    form.addEventListener('submit',(event)=>{if(!isConditionallyActive() || hasSelection())return;event.preventDefault();event.stopImmediatePropagation();showError('Sepete eklemeden önce Google işletmenizi seçin.');searchInput?.focus();searchInput?.scrollIntoView({behavior:'smooth',block:'center'});},true);
    document.addEventListener('click',(event)=>{if(!root.contains(event.target))hideResults();});
    syncSubmit();
  }

  function initAll(scope=document){scope.querySelectorAll?.(SELECTOR).forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll());else initAll();
  const observer=new MutationObserver((mutations)=>{for(const mutation of mutations){for(const node of mutation.addedNodes){if(!(node instanceof Element))continue;if(node.matches?.(SELECTOR))init(node);initAll(node);}}});
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
